import styled from '@emotion/styled';
import {colors, fonts} from 'ui/config';
import {HeadlineMedium, Img} from 'ui';

export const RecetteSteps = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: '#E5E6E7',
  padding: '40px 20px',
  marginBottom: 24,
});

export const Step = styled('div')({
  display: 'flex',
  marginBottom: 24,
  alignItems: 'start',
});

export const StepNumber = styled('div')({
  display: 'flex',
  width: 32,
  minWidth: 32,
  height: 32,
  backgroundColor: colors.white,
  color: colors.caramel,
  fontFamily: fonts.title,
  marginRight: 7,
  padding: '8px 12px',
  fontWeight: 'bold',
});

export const StepDescription = styled(HeadlineMedium)({
  display: 'flex',
  color: colors.grey,
  textAlign: 'left',
  margin: 0,
});

export const Steps = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  marginTop: 16,
});

export const RecipeImages = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const RecipeImage = styled(Img)({
  display: 'flex',
  width: 155,
  height: 117,
  objectFit: 'cover',
});

export const Images = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: 16,
  gap: 25,
});

export const RecipeImageWrapper = styled('div')({
  position: 'relative',
});

export const ImageNumber = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  top: 5,
  left: 5,
  width: 15,
  height: 15,
  borderRadius: 15,
  fontSize: 10,
  backgroundColor: 'white',
  border: '0.2px solid grey',
});
